import { PortalResult } from "./../types/portal/index";
import { ApiErrorType } from "./../enums";
import {
    Controllers,
    IsBadRequestResult,
    IsForbiddenResult,
    IsNotFoundResult,
    IsServerErrorResult,
    Portal,
    ProblemResult
} from "@infoland/iprova-api";
import Utils from "@/utils";

export function getPortalAsync(portalId: number, includeBackGroundImage: boolean = false): Promise<Portal | ProblemResult<string>> {
    return Controllers.GenericController.getAsync<Portal | ProblemResult<string>>(
        `portals/${portalId}?includeBackGroundImage=${includeBackGroundImage}`
    );
}
export async function getPortalForUserWithRedirectAsync(
    portalId: number,
    userId: string,
    redirectPath: string,
    includeBackGroundImage: boolean = false
): Promise<PortalResult> {
    const result = await getPortalAsync(portalId, includeBackGroundImage);
    return handleGetPortalResult(result, userId, redirectPath);
}

function handleGetPortalResult(result: Portal | ProblemResult<string>, userId: string, redirectPath: string): PortalResult {
    let portalResult: PortalResult = { portal: null, errorType: null, showError: false };

    if (IsServerErrorResult(result)) {
        portalResult.errorType = ApiErrorType.InternalServerError;
        return portalResult;
    }
    if (IsForbiddenResult(result)) {
        if (Utils.isAnonymousUser(userId)) {
            //open login
            Utils.navigateToLogin(redirectPath);
            return;
        }
        portalResult.errorType = ApiErrorType.Forbidden;
        portalResult.showError = true;
        return portalResult;
    }
    if (IsNotFoundResult(result)) {
        portalResult.errorType = ApiErrorType.NotFound;
        portalResult.showError = true;
        return portalResult;
    }
    if (IsBadRequestResult(result)) {
        portalResult.errorType = ApiErrorType.BadRequest;
        return portalResult;
    }

    portalResult.portal = result;
    return portalResult;
}
